import { VisuallyHidden } from '@rbilabs/components-library/build/components/visually-hidden';
import styled, { css } from 'styled-components';

import { IPickerAspectUiPattern } from '@rbi-ctg/menu';
import { isUiPatternRadio } from 'state/menu/types';

import { Size } from './constants';

import { ISelectionIndicatorProps } from '.';

export const HiddenInput = VisuallyHidden.withComponent('input');

interface IIndicatorContainer extends IPickerAspectUiPattern {
  checked: boolean;
  hasBackground?: boolean;
  type?: string;
}
export const IndicatorContainer = styled.div<IIndicatorContainer>`
  min-height: 1.5rem;
  position: relative;
  min-width: 1.5rem;

  input:focus + &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 2px solid ${Styles.color.grey.five};
    border-radius: ${p => (p.type === 'checkbox' ? '5px' : '50%')};
  }

  ${p =>
    isUiPatternRadio(p) &&
    css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      min-height: auto;
      min-width: auto;
      border: none;
      border-radius: 0;
      background-color: 0;

      ${HiddenInput}:focus + &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: none;
        border-radius: 0;
        outline-color: -webkit-focus-ring-color;
        outline-style: auto;
      }
    `}
`;

const setBackgroundColor = (p: ISelectionIndicatorProps) => {
  if (p.defaultValue) {
    return Styles.color.grey.one;
  } else if (p.checked) {
    return Styles.color.secondary;
  } else if (p.disabled) {
    return Styles.color.grey.four;
  } else {
    return '#ffffff';
  }
};

const Indicator = styled.span<ISelectionIndicatorProps>`
  background-color: ${p => setBackgroundColor(p)};
  border: ${p => (p.checked ? 'none' : `2px solid ${Styles.color.grey.five}`)};
  border-radius: ${p => (p.type === 'checkbox' ? '5px' : '50%')};
  height: ${p => p.size}rem;
  position: absolute;
  width: ${p => p.size}rem;
  ${p =>
    p.type === 'checkbox'
      ? css`
          &:after {
            border: solid ${Styles.color.white};
            border-width: 0 2px 2px 0;
            content: '';
            display: ${p.checked ? 'block' : 'none'};
            height: ${p.size * 0.42}rem;
            left: ${p.size * 0.42}rem;
            position: absolute;
            top: ${p.size * 0.22}rem;
            transform: rotate(45deg);
            width: ${p.size * 0.22}rem;
          }
        `
      : css`
          display: flex;
          justify-content: center;
          align-items: center;
          &:after {
            border: ${p.size === Size.REGULAR ? 0.1875 : 0.3125}rem solid #ffffff;
            content: '';
            width: ${p.size === Size.REGULAR ? 0.75 : 1}rem;
            height: ${p.size === Size.REGULAR ? 0.75 : 1}rem;
            border-radius: 50%;
            box-sizing: unset;
          }
        `}
`;

export default Indicator;
